export const FETCH_CATEGORY_GROUPS_REQUEST = 'FETCH_CATEGORY_GROUPS_REQUEST';
export const FETCH_CATEGORY_GROUPS_SUCCESS = 'FETCH_CATEGORY_GROUPS_SUCCESS';
export const FETCH_CATEGORY_GROUPS_FAILURE = 'FETCH_CATEGORY_GROUPS_FAILURE';

export const ADD_CATEGORY_GROUP_REQUEST = 'ADD_CATEGORY_GROUP_REQUEST';
export const ADD_CATEGORY_GROUP_SUCCESS = 'ADD_CATEGORY_GROUP_SUCCESS';
export const ADD_CATEGORY_GROUP_FAILURE = 'ADD_CATEGORY_GROUP_FAILURE';

export const UPDATE_CATEGORY_GROUP_REQUEST = 'UPDATE_CATEGORY_GROUP_REQUEST';
export const UPDATE_CATEGORY_GROUP_SUCCESS = 'UPDATE_CATEGORY_GROUP_SUCCESS';
export const UPDATE_CATEGORY_GROUP_FAILURE = 'UPDATE_CATEGORY_GROUP_FAILURE';

export const DELETE_CATEGORY_GROUP_REQUEST = 'DELETE_CATEGORY_GROUP_REQUEST';
export const DELETE_CATEGORY_GROUP_SUCCESS = 'DELETE_CATEGORY_GROUP_SUCCESS';
export const DELETE_CATEGORY_GROUP_FAILURE = 'DELETE_CATEGORY_GROUP_FAILURE';

export const SET_CATEGORY_GROUP_EDIT = 'SET_CATEGORY_GROUP_EDIT';
export const CLEAR_CATEGORY_GROUP_EDIT = 'CLEAR_CATEGORY_GROUP_EDIT'; 